<template lang="pug">
  el-main(:class="$style.main")
    el-row.padding-top-15(:gutter="40")
      el-col(:span="24")
        el-table(
          :data="courses" 
          :class="$style.courseTable" 
          border empty-text="No Courses"
          v-loading="loading"
        )
          el-table-column(label="Course Code" width="200")
            template(v-slot="scope")
              | {{ scope.row.code.toUpperCase() }} 
          el-table-column(label="Website")
            template(v-slot="scope")
              div(style="display: flex; justify-content: space-between; align-items: center;")
                a(:href="scope.row.url" target="_blank") {{ scope.row.title }}
                el-tooltip(
                  class="item"
                  effect="dark"
                  :content="scope.row.description ? 'Description: ' + scope.row.description : 'Description not provided'"
                  placement="top"
                )
                  i(class="el-icon-document" style="cursor: pointer;")

          el-table-column(label="Instructor")
            template(v-slot="scope")
              | {{ scope.row.instructor || user.name }}
          el-table-column(label="Email")
            template(v-slot="scope")
              a(:href="`mailto:${scope.row.email || user.email}`") {{ scope.row.email || user.email }}
          el-table-column(label="Backup Status" width="150" align="center")
            template(v-slot="scope")
              span(style="display: flex; align-items: center; justify-content: center;")
                i.el-icon-success(v-if="getBackupStatus(scope.row.latestBackup)" :class="$style.healthy")
                i.el-icon-warning(v-else-if="scope.row.latestBackup && scope.row.latestBackup.date" :class="$style.warning")
                i.el-icon-error(v-else :class="$style.warning")
                |  {{ getBackupDate(scope.row.latestBackup) }}
          el-table-column(label="Metrics" width="150" align="center")
            template(v-slot="scope")
              el-row(type="flex" align="middle")
                el-col(:style="{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }")
                  el-tooltip(
                    class="item"
                    effect="dark"
                    :content="`Total students: ${scope.row.students}`"
                    placement="top"
                  )
                    div(style="border: 1px dashed #dcdfe6; padding: 4px 6px; border-radius: 4px; display: flex; align-items: center; cursor: pointer")
                      span(style="margin-right: 2px; font-weight: bold; font-size: 1em; line-height: 1; align-self: flex-end") {{ scope.row.students }}
                      i.el-icon-user-solid
                el-col
                  el-button(type="primary" size="mini" icon="el-icon-pie-chart" @click="viewMetrics(scope.row.code)") 
        el-pagination(
          :class="$style.paginationBar"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :total="itemTotal"
          @current-change="handlePageChange"
        )
    metrics-modal(
      v-if="showMetrics"
      :code="selectedCourse"
      :show.sync="showMetrics"
    )
</template>

<script>
  import { mapState } from 'vuex'
  import MetricsModal from '@/masteradmin/components/MetricsModal'

  import { ACTION_GET_COURSES } from '@/masteradmin/store/actions'

  export default {
    components: {
      MetricsModal,
    },

    data() {
      return {
        currentPage: 1,
        showMetrics: false,
        selectedCourse: null,
      }
    },

    computed: {
      ...mapState({
        courses: state => state.courses.courses,
        user: state => state.user.user,
        isAuthenticated: state => state.user.isAuthenticated,
        itemTotal: state => state.courses.itemTotal,
        pageSize: state => state.courses.pageSize,
        loading: state => state.courses.loading,
      }),
    },

    created() {
      document.title = 'HVU Master Admin: Course List'
      this.getData()
    },

    methods: {
      getData() {
        this.$store.dispatch(ACTION_GET_COURSES, { page: this.currentPage })
      },
      handlePageChange(page) {
        this.currentPage = page
        this.getData()
      },
      viewMetrics(courseCode) {
        this.selectedCourse = courseCode
        this.showMetrics = true
      },

      getBackupDate(latestBackup) {
        let status = 'None'
        if (latestBackup && latestBackup.date) {
          status = new Date(latestBackup.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
        }
        return status
      },

      getBackupStatus(latestBackup) {
        let healthy = false
        if (latestBackup && latestBackup.date) {
          // Check if the difference is less than or equal to X days
          const today = new Date()
          const backupDate = new Date(latestBackup.date)
          healthy = (today - backupDate) <= (3 * 24 * 60 * 60 * 1000)
        }
        return healthy
      },
    },
  }
</script>

<style module>
  .main {
    padding: 40px 5% * 5%;
  }
  
  .courseTable {
    width: 100%;
    border-collapse: collapse;
    background-color: rgba(255, 255, 255, 0.55);
    color: var(--hvu-blue);
  }

  /* Style header cells within courseTable */
  .courseTable th {
    background-color: var(--button-blue) !important;
    color: white !important;
  }

  .paginationBar {
    margin-top: 24px;
    text-align: right;
    border-radius: 8px;
  }

  .paginationBar :global(.el-pagination__total) {
    color: white;
  }

  .warning {
    color: var(--warning);
    font-size: 1.5rem;
    font-weight: 700;
    margin-right: 0.25rem;
  }

  .healthy {
    color: var(--button-green);
    font-size: 1.5rem;
    font-weight: 700;
    margin-right: 0.25rem;
  }
</style>


// WEBPACK FOOTER //
// client/masteradmin/pages/CourseList/CourseList.vue